module.exports = __webpack_public_path__ + "img/bgc9.5a68cac4.png";